import {SchemaById} from 'lookup-config/LookupConfigModalConstants';
import {SchemaInfo} from 'processes/modals/field-mapping/FieldMappingConstants';
import {
  FlowchartEdge,
  TransitionSource,
  CustomMappingData,
} from 'processes/modals/field-mapping/transition-modal-with-flowchart-editor/transitionModalWithFlowchartEditorConstants';
import {NodeSection} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeTypes';

import {ProcessTaskSchemaGraphQL} from '../../../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaGraphQL';
import {TaskSchemaNodeRowData, TaskSchemaNode} from './TaskSchemaNodeRenderer';

export type TaskSchemaNodeRendererSection = NodeSection<TaskSchemaNodeRowData>;

export interface TaskDefinition {
  schemaInfo: SchemaInfo;
}

export interface NodeDetailsSidepanelContentProps {
  selectedNode: TaskSchemaNode;
  selectedFieldId: string | null;
  flowchart: {
    nodes: Array<TaskSchemaNode>;
    edges: Array<FlowchartEdge>;
  };
  allSchemasById: SchemaById;
  flowchartTaskSchema: ProcessTaskSchemaGraphQL;
  transitionSource: TransitionSource | null;
  customMappingDataByEdgeId: Record<string, CustomMappingData>;
  onChangeCustomMappingData: (edgeId: string, newCustomMappingData: CustomMappingData) => void;
  // TODO(BNCH-122158): add onChangeFlowchart callback
}

/**
 * Abstract class for creating sections of a node in a ProcessFlowchart.
 * For each node type, a different adapter can be created to handle
 * converting the task definition into a node to use in a flowchart.
 */
export abstract class ProcessFlowchartNodeAdapter<TNodeAdapterOptions> {
  constructor(protected readonly options: TNodeAdapterOptions) {}

  abstract createSections(taskDefinition: TaskDefinition): Array<TaskSchemaNodeRendererSection>;

  abstract nodeDetailsSidepanelContent(props: NodeDetailsSidepanelContentProps): JSX.Element;
}
